import * as actions from '../actions';
import { globalGetService, globalPostService, globalPutService } from '../../../../globalServices/';
import { toastFlashMessage } from '../../../../utils/';
import { trackActivity } from '../../../../utils/mixpanel';
import { addReturnCondition } from '../../contractAddObject';
export const returnCondListAc = (params) => {
  return (dispatch) => {
    dispatch({
      type: actions.RETURN_COND_LOADER,
      payload: true
    });
    globalGetService('contracts/'+params.contract_slug+'/return-condition-items/',{})
    .then(response => {
      dispatch({
        type: actions.RETURN_COND_LOADER,
        payload: false
      });
      if(response.data.statusCode == 200){
        dispatch({
          type: actions.RETURN_COND_LIST,
          payload: response.data.data
        })
      }
    })
  }
}


export const retuenConditionCrudAc = (params, type, id) => {
  return(dispatch) => {
    if(type == 'add'){
      dispatch({
        type: actions.RETURN_COND_CRUD,
        payload: {type: type, data:addReturnCondition , flag: true }
      });
    }else{
      dispatch({
        type: actions.RETURN_COND_LOADER,
        payload: true
      });
      globalGetService('contracts/'+params.contract_slug+'/return-condition-items/' + id + '/',{})
      .then(response => {
        dispatch({
          type: actions.RETURN_COND_LOADER,
          payload: false
        });
        if(response.data.statusCode == 200){
          dispatch({
            type: actions.RETURN_COND_CRUD,
            payload: {type: 'view', data: response.data.data, flag: true }
          });
        }
      })
    }
  }
}

export const addEditReturnCondAc = (params, data, type, assetViewId) => {
  return (dispatch) => {
    dispatch({
      type: actions.RETURN_COND_LOADER,
      payload: true
    });
    if(type == 'add'){
      globalPostService('contracts/'+params.contract_slug+'/return-condition-items/', data)
      .then(response => {
        dispatch({
          type: actions.RETURN_COND_LOADER,
          payload: false
        });
        if(response.data.statusCode == 200){
          dispatch({
            type: actions.RETURN_COND_ADD_SUCCESS,
            payload: response.data.data
          });
          dispatch({
            type: actions.RETURN_COND_CRUD,
            payload: {type: '', data:{} , flag: false }
          });
          toastFlashMessage(response.data.message, 'success');
          let assetTypeNames = {
            3: 'APU',
            4: 'LG',
            5: 'PROPELLER'
          }
          trackActivity('Item Added', {
            page_title: `Return Condition`,
            application_module: `Contracts`,
            asset: assetViewId.asset_type === 1 ? `MSN ${assetViewId.msn}` : [3,4,5].includes(assetViewId.asset_type) ? `${assetTypeNames[assetViewId.asset_type]} ${assetViewId.serial_number}` : `ESN ${assetViewId.esn}`,
            contract_slug: params.contract_slug,
            item_type: `Return Condition`,
            item_id: response.data.data.id
          })
        }
      })
    }else{
      globalPutService('contracts/'+params.contract_slug+'/return-condition-items/' + data.id + '/', data)
      .then(response => {
        dispatch({
          type: actions.RETURN_COND_LOADER,
          payload: false
        });
        if(response.data.statusCode == 200){
          dispatch({
            type: actions.RETURN_COND_EDIT_SUCCESS,
            payload: response.data.data
          });
          dispatch({
            type: actions.RETURN_COND_CRUD,
            payload: {type: '', data:{} , flag: false }
          });
          toastFlashMessage(response.data.message, 'success');
          let assetTypeNames = {
            3: 'APU',
            4: 'LG',
            5: 'PROPELLER'
          }
          trackActivity('Item Edited', {
            page_title: `Return Condition`,
            application_module: `Contracts`,
            asset: assetViewId.asset_type === 1 ? `MSN ${assetViewId.msn}` : [3,4,5].includes(assetViewId.asset_type) ? `${assetTypeNames[assetViewId.asset_type]} ${assetViewId.serial_number}` : `ESN ${assetViewId.esn}`,
            contract_slug: params.contract_slug,
            item_type: `Return Condition`,
            item_id: data.id
          })
        }
      })
    }
  }
}
